import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as alertActions from "../actions/alertActions";
import * as userActions from "../actions/userActions";

import { alertMessage } from "../helpers";
import ErrorHandler from "./common/ErrorHandler";
import LoginPage from "./login/LoginPage";
import ForgotPage from "./forgot/ForgotPage";
import ResetPage from "./reset/ResetPage";
import PrivateRoute from "./routes/PrivateRoute";
import UserRoute from "./routes/UserRoute";
import Loader from "./common/Loader";

function App({ actions, alert, auth, history }) {
  useEffect(() => {
    if (!window.location.pathname.includes("/reset")) {
      actions.authRefresh();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions.authRefresh]);

  useEffect(() => {
    if (alert) {
      alertMessage(alert);
    }
  }, [alert]);

  if (auth.isLoading && !window.location.pathname.includes("/reset")) {
    return (
      <div className="loading-page-asdfg">
        <div className="loading-page-loader-asdfg">
          <Loader loading />
        </div>
      </div>
    );
  }

  return (
    <ErrorHandler>
      <Switch>
        {auth.isAuth ? (
          <>
            <PrivateRoute path="/" component={UserRoute} auth={auth} />
          </>
        ) : (
          <>
            <Route exact path="/">
              <LoginPage />
            </Route>
            <Route path="/login">
              <LoginPage />
            </Route>
            <Route path="/forgot">
              <ForgotPage />
            </Route>
            <Route path="/reset/:token">
              <ResetPage />
            </Route>
          </>
        )}
      </Switch>
      <ToastContainer autoClose={2000} />
    </ErrorHandler>
  );
}

App.propTypes = {
  alert: PropTypes.object,
  auth: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state,
    auth: state.reducers.auth,
    alert: state.reducers.alert
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userActions, ...alertActions }, dispatch)
  };
}

export default withRouter(connect(mapStatesToProps, mapDispatchToProps)(App));
